import { Controller } from '@hotwired/stimulus'

const DEFAULT_MAX_HEIGHT = '360px'

export default class extends Controller {
  static targets = ['accordion', 'show', 'hide', 'btnArea']

  className () {
    return this.element.dataset.classname
  }

  connect () {
    this.accordionTargets.forEach((element, _index) => {
      if (element.clientHeight >= element.dataset.height) {
        this.showTarget.style.display = 'flex'
        this.hideTarget.style.display = 'none'
        this.accordionTargets[0].style.maxHeight = DEFAULT_MAX_HEIGHT
      } else {
        this.showTarget.style.display = 'none'
        this.hideTarget.style.display = 'none'
      }
    })
  }

  show (e) {
    e.target.previousElementSibling.style.display = 'flex'
    e.target.style.display = 'none'
    this.btnAreaTargets[0].classList.add(`${this.className()}::button-rest-area--open`)
    this.accordionTargets[0].style.maxHeight = 'none'
  }

  hide (e) {
    e.target.nextElementSibling.style.display = 'flex'
    e.target.style.display = 'none'
    this.btnAreaTargets[0].classList.remove(`${this.className()}::button-rest-area--open`)
    this.accordionTargets[0].style.maxHeight = DEFAULT_MAX_HEIGHT
  }
}
